import config from '../config';

// The backend's public /v2/dashboard_auth/ endpoints (apiv2/dashboard_auth.openapi.yaml):
// unauthenticated and throttled — no Auth0, no token.
export const DASHBOARD_AUTH_BASE = config.apiUrl.replace(/\/v\d+.*$/, '') + '/v2/dashboard_auth';

// The tenant is identified the way the sign-in does (GET /v2/edit/login/?host=…).
export const dashboardHost = () => config.domainOverride || window.location.host;

// "Forgot password?": POST {host, email}. The backend answers 202 {ok: true} whether or not an
// account exists (no enumeration), 400 when a field is missing, 429 when throttled.
// Resolves to 'sent' | 'missing' | 'throttled' | 'failed'; rejects on a network error.
export async function requestPasswordReset(email) {
    const res = await fetch(`${DASHBOARD_AUTH_BASE}/password_reset/request/`, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ host: dashboardHost(), email }),
    });
    if (res.status === 202 || res.ok) { return 'sent'; }
    if (res.status === 400) { return 'missing'; }
    if (res.status === 429) { return 'throttled'; }
    return 'failed';
}
